import SetupClassTeacher from "components/module/setupClassTeacher"

const ClassSetupBonusesPage = () => {
  return <SetupClassTeacher variant="bonus" />
}

export default ClassSetupBonusesPage
